import React from "react";
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { multilineStyles } from "@icarius-common/textFieldMultiline";

const MultilineInput = (props) => {
    const {
        fieldConfig,
        label,
        value,
        handleChange,
        required,
        error,
        classes,
    } = props;

    const hasAudioPlayer = fieldConfig.audioPlayer;

    return (
        <TextField
            required={required}
            fullWidth
            multiline
            rows={fieldConfig.rows || 5}
            variant={hasAudioPlayer ? "standard" : "outlined"}
            margin={"none"}
            label={label}
            value={value}
            onChange={(e) => handleChange(e.target.value, fieldConfig.name)}
            InputLabelProps={!hasAudioPlayer ? {
                classes: {
                    root: classes.cssLabel,
                    focused: classes.cssFocused,
                },
            } : {}}
            InputProps={!hasAudioPlayer ? {
                classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                }
            } : {}}
            error={error}
            inputProps={{ spellCheck: 'false' }}
        />
    )
}

export default withStyles(multilineStyles)(MultilineInput);